"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CCPARequest = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.match");

var _palette = require("@artsy/palette");

var _Artsy = require("../../Artsy");

var _Constants = require("../Publishing/Constants");

var _react = _interopRequireWildcard(require("react"));

var _reactRelay = require("react-relay");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _errors = require("../../Utils/errors");

var _get = require("../../Utils/get");

var _logger = _interopRequireDefault(require("../../Utils/logger"));

var _graphql,
    _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var logger = (0, _logger.default)("Components/V2/CCPARequest.tsx");
var FeedbackTextAreaContainer = (0, _styledComponents.default)(_palette.Box).withConfig({
  displayName: "CCPARequest__FeedbackTextAreaContainer",
  componentId: "sc-80jge3-0"
})(["max-width:484px;width:100%;"]);
var IconContainer = (0, _styledComponents.default)(_palette.Box).withConfig({
  displayName: "CCPARequest__IconContainer",
  componentId: "sc-80jge3-1"
})(["margin:0 auto;"]);

var Feedback = function Feedback(_ref) {
  var setNotes = _ref.setNotes,
      notes = _ref.notes,
      triggeredValidation = _ref.triggeredValidation;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_palette.Sans, {
    weight: "medium",
    size: "3"
  }, "Your message"), _react.default.createElement(FeedbackTextAreaContainer, {
    mt: 1
  }, _react.default.createElement(_palette.TextArea, {
    onChange: function onChange(_ref2) {
      var value = _ref2.value;
      setNotes(value);
    },
    placeholder: "Describe your data request",
    required: true,
    error: errorForText({
      triggeredValidation: triggeredValidation,
      text: notes
    })
  })));
};

var errorForEmail = function errorForEmail(_ref3) {
  var triggeredValidation = _ref3.triggeredValidation,
      email = _ref3.email;
  if (!triggeredValidation) return;
  if (!email) return "Cannot leave field blank.";
  if (!email.match(_Constants.EMAIL_REGEX)) return "Please enter a valid email.";
};

var errorForText = function errorForText(_ref4) {
  var triggeredValidation = _ref4.triggeredValidation,
      text = _ref4.text;
  if (!triggeredValidation) return;
  if (!text) return "Cannot leave field blank.";
};

var hasErrors = function hasErrors(_ref5) {
  var user = _ref5.user,
      triggeredValidation = _ref5.triggeredValidation,
      notes = _ref5.notes,
      name = _ref5.name,
      email = _ref5.email;
  if (user) return !!errorForText({
    triggeredValidation: triggeredValidation,
    text: notes
  });
  return !!(errorForEmail({
    triggeredValidation: triggeredValidation,
    email: email
  }) || errorForText({
    triggeredValidation: triggeredValidation,
    text: name
  }) || errorForText({
    triggeredValidation: triggeredValidation,
    text: notes
  }));
};

var LoggedOutContents = function LoggedOutContents(_ref6) {
  var triggeredValidation = _ref6.triggeredValidation,
      setName = _ref6.setName,
      setEmail = _ref6.setEmail,
      setNotes = _ref6.setNotes,
      email = _ref6.email,
      name = _ref6.name,
      notes = _ref6.notes;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Header, null), _react.default.createElement(Feedback, {
    notes: notes,
    triggeredValidation: triggeredValidation,
    setNotes: setNotes
  }), _react.default.createElement(_palette.Box, {
    mt: 1
  }, _react.default.createElement(_palette.Input, {
    name: "name",
    placeholder: "Your full name",
    onChange: function onChange(_ref7) {
      var value = _ref7.currentTarget.value;
      setName(value);
    },
    required: true,
    error: errorForText({
      text: name,
      triggeredValidation: triggeredValidation
    })
  })), _react.default.createElement(_palette.Box, {
    mt: 1
  }, _react.default.createElement(_palette.Input, {
    name: "email",
    placeholder: "Your email address",
    onChange: function onChange(_ref8) {
      var value = _ref8.currentTarget.value;
      setEmail(value);
    },
    required: true,
    error: errorForEmail({
      email: email,
      triggeredValidation: triggeredValidation
    })
  })));
};

var LoggedInContents = function LoggedInContents(_ref9) {
  var triggeredValidation = _ref9.triggeredValidation,
      notes = _ref9.notes,
      email = _ref9.email,
      setNotes = _ref9.setNotes;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Header, null), _react.default.createElement(_palette.Separator, {
    mt: 3
  }), _react.default.createElement(_palette.Box, {
    my: 1
  }, _react.default.createElement(_palette.Serif, {
    size: "3"
  }, "From: ", email)), _react.default.createElement(_palette.Separator, {
    mb: 3
  }), _react.default.createElement(Feedback, {
    notes: notes,
    triggeredValidation: triggeredValidation,
    setNotes: setNotes
  }));
};

var Header = function Header() {
  return _react.default.createElement(_palette.Serif, {
    size: "4",
    textAlign: "center"
  }, "Our", " ", _react.default.createElement(_palette.Link, {
    target: "_blank",
    href: "/privacy"
  }, "Privacy Policy"), " ", "has the information we collect, how we use it, and why we use it.", "\n", "You can also email", " ", _react.default.createElement(_palette.Link, {
    href: "mailto:privacy@artsy.net"
  }, "privacy@artsy.net"), " for more information or to submit a request.");
};

var SuccessScreen = function SuccessScreen() {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(IconContainer, {
    pt: 1
  }, _react.default.createElement(_palette.CheckCircleIcon, {
    fill: "green100",
    height: "32",
    width: "32"
  })), _react.default.createElement(_palette.Box, {
    mt: 3,
    textAlign: "center"
  }, _react.default.createElement(_palette.Serif, {
    size: "4"
  }, "We've received your message.")));
};

var sendDataRequest = function sendDataRequest(_ref10) {
  var relayEnvironment = _ref10.relayEnvironment,
      email = _ref10.email,
      notes = _ref10.notes,
      name = _ref10.name,
      setSubmitted = _ref10.setSubmitted;
  (0, _reactRelay.commitMutation)(relayEnvironment, {
    mutation: _graphql || (_graphql = function _graphql() {
      var node = require("../../__generated__/CCPARequestMutation.graphql");

      if (node.hash && node.hash !== "261c7e53f35fe29653572bf16c4f031a") {
        console.error("The definition of 'CCPARequestMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data.");
      }

      return require("../../__generated__/CCPARequestMutation.graphql");
    }),
    variables: {
      input: {
        notes: notes,
        email: email,
        name: name,
        action: "user_data"
      }
    },
    // Add slight delay to make UX seem a bit nicer
    optimisticUpdater: function optimisticUpdater() {
      setTimeout(function () {
        return setSubmitted(true);
      }, 500);
    },
    onCompleted: function onCompleted(data) {
      var accountRequestOrError = data.createAccountRequest.accountRequestOrError;

      if (accountRequestOrError.mutationError) {
        logger.error(new _errors.ErrorWithMetadata(accountRequestOrError.mutationError.type, accountRequestOrError.mutationError.message));
      } else {
        setSubmitted(true);
      }
    }
  });
};

var CCPARequest = function CCPARequest(props) {
  var user = props.user;

  var _useSystemContext = (0, _Artsy.useSystemContext)(),
      relayEnvironment = _useSystemContext.relayEnvironment;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      notes = _useState4[0],
      setNotes = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      email = _useState6[0],
      setEmail = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      name = _useState8[0],
      setName = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      triggeredValidation = _useState10[0],
      setTriggeredValidation = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      clickedSubmit = _useState12[0],
      setClickedSubmit = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      submitted = _useState14[0],
      setSubmitted = _useState14[1];

  var userEmail = (0, _get.get)(props, function (p) {
    return p.user.email;
  });
  var modalContents = submitted ? _react.default.createElement(SuccessScreen, null) : !user ? _react.default.createElement(LoggedOutContents, {
    email: email,
    name: name,
    notes: notes,
    triggeredValidation: triggeredValidation,
    setName: setName.bind(_this),
    setEmail: setEmail.bind(_this),
    setNotes: setNotes.bind(_this)
  }) : _react.default.createElement(LoggedInContents, {
    notes: notes,
    email: userEmail,
    triggeredValidation: triggeredValidation,
    setNotes: setNotes.bind(_this)
  });
  (0, _react.useEffect)(function () {
    if (clickedSubmit) {
      if (hasErrors({
        user: user,
        email: email,
        name: name,
        notes: notes,
        triggeredValidation: triggeredValidation
      })) {
        setClickedSubmit(false);
        return;
      }

      sendDataRequest({
        relayEnvironment: relayEnvironment,
        email: email,
        name: name,
        notes: notes,
        setSubmitted: setSubmitted
      });
    }
  }, [clickedSubmit]);
  var modalButton = submitted ? _react.default.createElement(_palette.Button, {
    width: "100%",
    onClick: function onClick() {
      return setShowModal(false);
    }
  }, "Return to Artsy") : _react.default.createElement(_palette.Button, {
    width: "100%",
    onClick: function onClick() {
      setTriggeredValidation(true);
      setClickedSubmit(true);
    }
  }, "Send message");

  var onClose = function onClose() {
    setEmail(null);
    setName(null);
    setSubmitted(false);
    setNotes(null);
    setShowModal(false);
    setTriggeredValidation(false);
  };

  var title = submitted ? "Message sent" : "Personal Data Request";
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_palette.Box, {
    style: {
      cursor: "pointer"
    },
    onClick: function onClick() {
      return setShowModal(true);
    }
  }, "Do not sell my personal information"), _react.default.createElement(_palette.Modal, {
    title: title,
    forcedScroll: false,
    show: showModal,
    onClose: onClose,
    FixedButton: modalButton
  }, modalContents));
};

exports.CCPARequest = CCPARequest;
//# sourceMappingURL=CCPARequest.js.map